import * as Styled from "./styles";

interface PhoneNumberProps {
  phoneNumber: string;
}

const PhoneNumber = ({ phoneNumber }: PhoneNumberProps) => {
  // Strip out all non-digit characters
  const digits = phoneNumber.replace(/\D/g, "");

  const formattedNumber = `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 10)}`;

  return (
    <Styled.Link className="bold" href={`tel: 1 ${formattedNumber}`}>
      {formattedNumber}
    </Styled.Link>
  );
};

export default PhoneNumber;
